// import packages
import React, { Component } from "react";
import Slider from "react-slick";
import { connect } from "react-redux";

//Import styles
import "./mainSlider.scss";
import { ArrowLeft, ArrowRight } from "../../../assets/images";

// Import utils
import { generateImageMediaUrl, generateSliderMediaUrl } from "../../../utils/generateMediaUrl";
import { getPropsFromState } from "../../../redux/mapStateToProps";
import { ProgressBar } from "../../../components/progress-bar/Progress-Bar";

class MainSlider extends Component {
    constructor () {
        super();
        this.state = {
            slideIndex: 0,
            loadedImg: false,
            sliderCircleEnded: false,
        };
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
    }

    getSliderIndex = (index) => {
        this.setState({
            slideIndex: index,
        });
        this.slider.slickGoTo(index);
    };

    nextSlide = (index) => {
        const { mainSlider } = this.props;
        this.setState({
            slideIndex: this.state.slideIndex - 1 === index ? 0 : index + 1,
        });
        if (mainSlider?.length - 1 === this.state.slideIndex) {
            this.setState({
                slideIndex: 0,
            });
        }
        this.slider.slickNext();
    };

    prevSlide = (index) => {
        const { mainSlider } = this.props;
        this.setState({
            slideIndex: index === 0 ? mainSlider?.length - 1 : index - 1,
        });
        this.slider.slickPrev();
    };

    handleImageLoaded (index) {
        if (!this.state.loadedImg) {
            this.setState({ loadedImg: true });
        }
    }

    afterChangeSlideIndex = (slideIndex) => {
        this.setState({
            sliderCircleEnded: false,
        })
    };

    beforeChangeSlideIndex = (_, slideIndex) => {
        this.setState({
            slideIndex,
            sliderCircleEnded: true,
        })
    };

    render () {
        const { slideIndex, sliderCircleEnded } = this.state;
        const { mainSlider } = this.props;
        // console.log(mainSlider,'mainSlider')
        const settings = {
            dots: false,
            arrows: false,
            infinite: true,
            autoplaySpeed: 3800,
            speed: 1000,
            autoplay: false,
            pauseOnHover: false,
            lazyLoad: 'progressive',
            swipeToSlide: true,
            swipe: true,
            ref: slider => (this.slider = slider),
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: this.afterChangeSlideIndex,
            beforeChange: this.beforeChangeSlideIndex,
            fade: true,
        };


        return !!mainSlider && !!mainSlider.length && <div className="image-wrapper">
            <div className={'main-slider-items'}>
                <div className={'slider-btn prev-btn'}
                     onClick={() => this.prevSlide(slideIndex)}>
                    {'<'}
                </div>
                <div className={'main-slider-inner-part'}>
                    <Slider {...settings}>
                        {mainSlider?.length && mainSlider?.map((item, index) => {
                            const imagePath = window?.innerWidth > 600 ? item?.mediaMain?.path : (item?.responsiveMedia?.path ? item?.responsiveMedia?.path : item?.mediaMain?.path)
                            let title = item?.title
                            const firstIndex = title.indexOf('%s')
                            const lastIndex = title.lastIndexOf('%s')

                            if (firstIndex !== -1 && lastIndex !== -1 && firstIndex !== lastIndex) {
                                title = title.replace('%s', `${firstIndex === 0 ? "": '&nbsp;'}<span>`);
                                title = title.replace('%s', `</span>`);
                            }
                            return <div key={item.id} className={`slider-item`} ref={this.img}>
                                <img src={generateImageMediaUrl(imagePath)} alt={""}
                                     onLoad={() => this.handleImageLoaded(index)}/>
                                <div className={'slider-description'} dangerouslySetInnerHTML={{__html: title}}>
                                </div>
                                {/*<div className={'slider-description'}>*/}
                                {/*    {item?.title.slice(0, 4)}<span>{item?.title.slice(5, 17)}</span>{item?.title.slice(17, item?.title.length)}*/}
                                {/*</div>*/}
                            </div>
                        })}
                    </Slider>
                </div>
                <div className={'slider-btn next-btn'}
                     onClick={() => this.nextSlide(slideIndex)}>
                    >
                </div>
                <div className={'bar-wrapper'}>
                    <ProgressBar slideIndex={slideIndex}
                                 sliderCircleEnded={sliderCircleEnded}
                                 sliderLenght={mainSlider?.length}
                                 slider={mainSlider}
                    />
                </div>
            </div>
        </div>
    }
}


const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'mainSlider',
        'contact',
    ])
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainSlider);
